import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions, keepPreviousData} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {mapPlantConfig} from '../mappers'
import {Config, ConfigDto} from '../types'

const querKeyPrefix = 'shifthandover-plant-config'

type UsePlantConfigParams = {
  plantId?: string
  language: string
  options?: Omit<UseQueryOptions<Config, AxiosError>, 'queryKey' | 'queryFn'>
}

export const usePlantConfig = ({plantId, language, options}: UsePlantConfigParams) => {
  return useQuery<Config, AxiosError>({
    queryKey: [querKeyPrefix, plantId, language],
    queryFn: async ({signal}) => {
      const path = `/shifthandover/${plantId}/config`
      const config = {
        params: {
          language
        },
        signal
      }

      const response = await ApiClient.axiosInstance.get<ConfigDto>(path, config)
      return mapPlantConfig(response.data)
    },
    enabled: !!plantId,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    ...options
  })
}
